<template>
  <div id="projects">
    <div
      class="uk-section uk-section-secondary uk-light uk-margin uk-margin-remove"
    >
      <div class="uk-container">
        <div class="uk-container">
          <h1>Projects</h1>
          <div class="uk-grid-match uk-child-width-1-2@m" uk-grid>
            <div>
              <h5>
                All projects are hosted on
                <a
                  class="uk-button uk-button-text uk-button-active uk-light"
                  href="https://github.com/ronitrex/"
                  target="_blank"
                  >github</a
                >. Each project is accompanied by an extensive readme. The
                readme contains the necessary information and resources to
                understand and run the project.
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="uk-container uk-container-expand uk-margin uk-margin-small uk-padding uk-padding-large"
    >
      <div
        class="uk-child-width-1-2@m uk-grid uk-grid-small uk-grid-match"
        uk-grid
        uk-scrollspy="cls: uk-animation-fade; target: .uk-card; delay: 100; repeat: true"
      >
        <div v-for="card in cards" v-bind:key="card.id">
          <ProjectCards
            :description="card.description"
            :items="card.items"
            :label="card.label"
            :stack="card.stack"
            :name="card.name"
            :link="card.link"
          ></ProjectCards>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectCards from "./ProjectCards.vue";

export default {
  name: "ProjectSection",
  components: { ProjectCards },
  data() {
    return {
      cards: [
        {
          id: 1,
          name: "ARM-LEGv8 CPU",
          label: "VERILOG",
          stack: "verilog, iverilog, Sigasi Studio, GTKWave",
          description:
            "Multi-cycle pipelined ARM-LEGv8 CPU with Forwarding and Hazard Detection.",
          link: "https://github.com/ronitrex/ARMLEG",
          items: [
            {
              id: 1,
              title:
                "The ARMv8 architecture is a 64-bit architecture. The LEG v8 instruction set is a subset of ARM v8 instruction set.",
            },
            {
              id: 2,
              title:
                "The 32-bit ARMv7 architecture had 15 general purpose registers, each 32-bits wide. The ARMv8 architecture has 31 general registers, each 64-bits wide.",
            },
            {
              id: 3,
              title:
                "The CPU can execute memory-reference instructions like LDUR and STUR, arithmetic-logical instructions like ADD, SUB, AND and ORR and branch instructions like B and CBZ.",
            },
          ],
        },
        {
          id: 2,
          name: "Mental Health",
          label: "PYTHON",
          stack: "python3, Anaconda Data Science Platform, JupyterLab, Spyder",
          description:
            "Supervised Machine Learning model trained on OSMIhelp.org mental health datasets.",
          link: "https://github.com/ronitrex/MentalHealth",
          items: [
            {
              id: 1,
              title:
                '<a href="https://github.com/ronitrex/MentalHealth/blob/master/DataCleanup.ipynb" target="_blank">Jupyter Notebook DataCleanup:</a>  Datasets from years 2014, 2016, 2017, 2018 and 2019 were cleaned and combined into one mega dataset.',
            },
            {
              id: 2,
              title:
                '<a href="https://github.com/ronitrex/MentalHealth/blob/master/DataAnalysis.ipynb" target="_blank">Jupyter Notebook DataAnalysis:</a>  Exploratory data analysis was performed to find data trends and important features of the dataset.',
            },
            {
              id: 3,
              title:
                '<a href="https://github.com/ronitrex/MentalHealth/blob/master/SupervisedLearning.ipynb" target="_blank">Jupyter Notebook SupervisedLearning:</a>  The cleaned dataset was used to train various supervised learning models. The highest prediction accuracy achieved for identifying whether a person could be suffering from mental health illness is about 81%.',
            },
          ],
        },
        {
          id: 3,
          name: "Search Engine",
          label: "JAVA",
          stack: "java, junit, Google gson, IntelliJ IDEA",
          description:
            "Advanced Search Engine featuring Boolean Search and Ranked Retrieval.",
          link: "https://github.com/ronitrex/SearchEngine",
          items: [
            {
              id: 1,
              title:
                "JSON (.json) or TEXT (.txt) files from a directory are indexed to create a positional inverted index and calculate additional features like term frequency and inverse document frequency.",
            },
            {
              id: 2,
              title:
                "In Boolean Search mode, all results satisfying the user query are shown. In Ranked Retrieval mode, only the top 20 ranked results are shown.",
            },
            {
              id: 3,
              title:
                "For Ranked Query Mode, several notable mathematical formulas of relevance are used based on the work of famed scientist Karen Spärck Jones.",
            },
          ],
        },
        {
          id: 4,
          name: "Travelling Salesman",
          label: "C++",
          stack: "C++, cmake, CLion",
          description:
            "Multi-threaded optimal solution for Travelling Salesman Problem using Branch and Bound.",
          link: "https://github.com/ronitrex/TravellingSalesman",
          items: [
            {
              id: 1,
              title:
                "It is a NP-hard problem in graph theory requiring the most efficient (i.e., least total distance) Hamiltonian cycle a salesman can take through each of n cities.",
            },
            {
              id: 2,
              title:
                "Branch and Bound heuristic means if the lower bound for a possible solution is as high or higher than the lowest cost solution found so far, the former solution is discarded and not considered any further.",
            },
            {
              id: 3,
              title:
                "To provide thread-based parallelism and concurrency, the maximum number of threads available to the system are automatically used, leading to massive improvement in performance on multi-core systems.",
            },
          ],
        },
        {
          id: 5,
          name: "Personal Website",
          label: "VUE",
          stack: "html5, javascript, CSS, UIkit, Vuejs, Travis CI, WebStorm",
          description:
            'Personal website deployed at <a href="https://github.com/ronitrex/ronitrex.github.io" target="_blank">ronitrex.github.io</a>',
          link: "https://github.com/ronitrex/PersonalWebsite",
          items: [
            {
              id: 1,
              title:
                "Frontend was created using modern web frameworks like Vuejs and UIkit. Single File Components (.vue files) are used to encapsulate CSS styles, template and JavaScript definition in the same place for every component.",
            },
            {
              id: 2,
              title:
                "Continuous Integration with Travis CI and Continuous Deployment with github-pages.",
            },
            {
              id: 3,
              title:
                '<a href="./testCards.html" target="_blank">RESTful API Testing page</a> is an example of a full stack MEVN application. It\'s backend server uses REST APIs that require Express, Axios and MongoDB.',
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
h1,
h5 {
  font-family: "overpass", sans-serif;
  font-weight: 600;
  font-style: normal;
}
</style>
